module.exports = __webpack_public_path__ + "static/media/2.19_preview.52caa153.png";